import { useMemo } from "react";
import { Calendar } from "@/components/ui/calendar";
import { Card, CardContent } from "@/components/ui/card";
import { isSameDay } from "date-fns";
import { sv } from "date-fns/locale";

interface MiniCalendarWidgetProps {
  bookings: Array<{ start_time: string }>;
  onDayClick: (date: Date) => void;
  selectedDate?: Date;
}

export default function MiniCalendarWidget({
  bookings,
  onDayClick,
  selectedDate,
}: MiniCalendarWidgetProps) {
  const bookingDates = useMemo(() => {
    return bookings.map((b) => new Date(b.start_time));
  }, [bookings]);

  const hasBooking = (day: Date) =>
    bookingDates.some((bd) => isSameDay(bd, day));

  return (
    <Card>
      <CardContent className="p-2">
        <Calendar
          mode="single"
          selected={selectedDate}
          onSelect={(date) => date && onDayClick(date)}
          locale={sv}
          modifiers={{ hasBooking: (day) => hasBooking(day) }}
          modifiersClassNames={{
            hasBooking: "relative",
          }}
          components={{
            DayContent: ({ date }) => (
              <div className="relative flex items-center justify-center">
                <span>{date.getDate()}</span>
                {hasBooking(date) && (
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 h-1 w-1 rounded-full bg-primary" />
                )}
              </div>
            ),
          }}
        />
      </CardContent>
    </Card>
  );
}
